import { formView as formViewEvent } from '@wix/bi-logger-forms-platform-uou/v2';
import { Form, FormStatusProvider, useBi } from '@wix/form-fields';
import React, { useCallback, useEffect } from 'react';
import { DATA_HOOKS } from '../../tpa/widget/data-hooks';
import { reportErrorChanges } from '../../hooks/use-validation';
import { SubmitStatusMessage } from '../submit-status-message/submit-status-message';
import { useForm } from '../../hooks/use-form';
import { StepTitleA11y } from './step-title-a11y';
export const FormRoot = ({ form: unprocessedForm, // renaming form to prevent accidental use
values: unprocessedValues, // renaming values to prevent accidental use
stepId, onStepIdChange, onChange, errors, onValidate, onSubmit, onSubmitSuccess, onSubmitFailure, forwardedRef, readOnly, overrides, actions, inProgress, config, breakpoint, onStatusChange, validationMode, fields, }) => {
    const bi = useBi();
    const _onValidate = useCallback((newErrors) => {
        reportErrorChanges({
            bi,
            existingErrors: errors,
            newErrors,
            form: unprocessedForm,
        });
        onValidate(newErrors);
    }, [bi, errors, onValidate, unprocessedForm]);
    const { formWithOverrides, normalizedValues, onFieldChange, currentStep, fieldActions, handleFieldValidation, currentView, formViews, } = useForm({
        form: unprocessedForm,
        values: unprocessedValues,
        stepId,
        onStepIdChange,
        onChange,
        errors,
        onValidate: _onValidate,
        onSubmit,
        onSubmitSuccess,
        onSubmitFailure,
        fieldMap: fields,
        config,
        overrides,
        actions,
        inProgress,
        breakpoint,
        validationMode,
        forwardedRef,
    });
    useEffect(() => {
        bi.report(formViewEvent({ mode: readOnly ? 'preview' : 'live_site' }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!formViews?.length || !currentView) {
        return null;
    }
    return (React.createElement(FormStatusProvider, { onStatusChange: onStatusChange },
        React.createElement("div", { "data-hook": DATA_HOOKS.FORM_ROOT },
            React.createElement(Form, { formSchema: formWithOverrides, form: currentView, values: normalizedValues, onFieldChange: onFieldChange, errors: errors, dataHook: DATA_HOOKS.FORM_ROOT, validateFields: handleFieldValidation, fields: fields, fieldActions: fieldActions }),
            React.createElement(StepTitleA11y, { total: formWithOverrides.steps?.length, index: currentStep }),
            React.createElement(SubmitStatusMessage, null))));
};
//# sourceMappingURL=form-root.js.map